export const inputStyle = {
  width: "100%",
  padding: "8px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  fontSize: "14px"
};

export const buttonStyle = {
  display: "inline-block",
  width: "100px",
  padding: "10px",
  backgroundColor: "#39853c",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  marginRight: "10px"
};

export const containerStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  fontSize: "14px",
  backgroundColor: "#f1f1f1",
  color: "#333",
  marginBottom: "10px"
};

export const preStyle = {
  margin: 0,
  fontSize: "14px",
  backgroundColor: "#f9f9f9",
  padding: "10px",
  borderRadius: "4px"
};

export const labelStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  backgroundColor: "#ffffff",
  color: "#333",
  marginTop: "10px",
  overflowY: "auto" as const,
  maxHeight: "600px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word" as const,
  maxWidth: "100%"
};

export const pageFont: React.CSSProperties = {
  width: "800px",
  margin: "20px",
  fontFamily: "Arial, sans-serif",
  textAlign: "left"
};

export const bodyFont = {
  border: "1px solid #ccc",
  padding: "10px",
  borderRadius: "5px",
  width: "100%"
};
export enum Mode {
  Regular = "Regular",
  Batch = "Batch"
}

export const headerFont = { display: "block", marginBottom: "5px", fontWeight: "bold" };
